import http from '@/assets/common/http';
// 登录
export function login(data) {
  const params = {
    SERVICE_ID: '10000',
    OTYPE: 1,
    ...data,
  };
  return http.post(params);
}
// 注销
export function logout(data) {
  const params = {
    SERVICE_ID: '10000',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}
// 修改密码
export function editPass(data) {
  const params = {
    SERVICE_ID: '10000',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}
// 根据页面ID拉取功能编号
export function getActionFun(data) {
  const params = {
    SERVICE_ID: '10060',
    OTYPE: 1,
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/login.js